/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Impero Org API
 * The Impero Backend's API for organizations, i.e. orgname.impero.com.
 */
import { useQuery, useSuspenseQuery } from "@tanstack/react-query";
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseQueryResult,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseQueryOptions,
    UseQueryResult,
    UseSuspenseQueryOptions,
    UseSuspenseQueryResult,
} from "@tanstack/react-query";

import axios from "axios";
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

import type { Culture, IanaTimezoneView } from "../model";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

const withQueryKey = <T extends object, K>(
    query: T,
    queryKey: K
): T & { queryKey: K } => {
    const result = { queryKey } as T & { queryKey: K };
    for (const key of Object.keys(query)) {
        // The explicit queryKey always wins, matching the previous
        // `{ ...query, queryKey }` spread where it was set last.
        if (key === "queryKey") continue;
        Object.defineProperty(result, key, {
            enumerable: true,
            configurable: true,
            get: () => (query as Record<string, unknown>)[key],
        });
    }
    return result;
};

export const getCultures = (
    options?: AxiosRequestConfig
): Promise<AxiosResponse<Culture[]>> => {
    return axios.get(`/api/cultures`, options);
};

export const getGetCulturesQueryKey = () => {
    return [`/api/cultures`] as const;
};

export const getGetCulturesQueryOptions = <
    TData = Awaited<ReturnType<typeof getCultures>>,
    TError = AxiosError<unknown>,
>(options?: {
    query?: Partial<
        UseQueryOptions<Awaited<ReturnType<typeof getCultures>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
}) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetCulturesQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCultures>>> = ({
        signal,
    }) => getCultures({ signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getCultures>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCulturesQueryResult = NonNullable<
    Awaited<ReturnType<typeof getCultures>>
>;
export type GetCulturesQueryError = AxiosError<unknown>;

export function useGetCultures<
    TData = Awaited<ReturnType<typeof getCultures>>,
    TError = AxiosError<unknown>,
>(
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getCultures>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getCultures>>,
                    TError,
                    Awaited<ReturnType<typeof getCultures>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCultures<
    TData = Awaited<ReturnType<typeof getCultures>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getCultures>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getCultures>>,
                    TError,
                    Awaited<ReturnType<typeof getCultures>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCultures<
    TData = Awaited<ReturnType<typeof getCultures>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getCultures>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetCultures<
    TData = Awaited<ReturnType<typeof getCultures>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getCultures>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetCulturesQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetCulturesSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getCultures>>,
    TError = AxiosError<unknown>,
>(options?: {
    query?: Partial<
        UseSuspenseQueryOptions<
            Awaited<ReturnType<typeof getCultures>>,
            TError,
            TData
        >
    >;
    axios?: AxiosRequestConfig;
}) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetCulturesQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCultures>>> = ({
        signal,
    }) => getCultures({ signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getCultures>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCulturesSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getCultures>>
>;
export type GetCulturesSuspenseQueryError = AxiosError<unknown>;

export function useGetCulturesSuspense<
    TData = Awaited<ReturnType<typeof getCultures>>,
    TError = AxiosError<unknown>,
>(
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getCultures>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCulturesSuspense<
    TData = Awaited<ReturnType<typeof getCultures>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getCultures>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCulturesSuspense<
    TData = Awaited<ReturnType<typeof getCultures>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getCultures>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetCulturesSuspense<
    TData = Awaited<ReturnType<typeof getCultures>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getCultures>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetCulturesSuspenseQueryOptions(options);

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getExtensions = (
    options?: AxiosRequestConfig
): Promise<AxiosResponse<string[]>> => {
    return axios.get(`/api/extensions`, options);
};

export const getGetExtensionsQueryKey = () => {
    return [`/api/extensions`] as const;
};

export const getGetExtensionsQueryOptions = <
    TData = Awaited<ReturnType<typeof getExtensions>>,
    TError = AxiosError<unknown>,
>(options?: {
    query?: Partial<
        UseQueryOptions<
            Awaited<ReturnType<typeof getExtensions>>,
            TError,
            TData
        >
    >;
    axios?: AxiosRequestConfig;
}) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetExtensionsQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getExtensions>>> = ({
        signal,
    }) => getExtensions({ signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getExtensions>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetExtensionsQueryResult = NonNullable<
    Awaited<ReturnType<typeof getExtensions>>
>;
export type GetExtensionsQueryError = AxiosError<unknown>;

export function useGetExtensions<
    TData = Awaited<ReturnType<typeof getExtensions>>,
    TError = AxiosError<unknown>,
>(
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getExtensions>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getExtensions>>,
                    TError,
                    Awaited<ReturnType<typeof getExtensions>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetExtensions<
    TData = Awaited<ReturnType<typeof getExtensions>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getExtensions>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getExtensions>>,
                    TError,
                    Awaited<ReturnType<typeof getExtensions>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetExtensions<
    TData = Awaited<ReturnType<typeof getExtensions>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getExtensions>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetExtensions<
    TData = Awaited<ReturnType<typeof getExtensions>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getExtensions>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetExtensionsQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetExtensionsSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getExtensions>>,
    TError = AxiosError<unknown>,
>(options?: {
    query?: Partial<
        UseSuspenseQueryOptions<
            Awaited<ReturnType<typeof getExtensions>>,
            TError,
            TData
        >
    >;
    axios?: AxiosRequestConfig;
}) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetExtensionsQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getExtensions>>> = ({
        signal,
    }) => getExtensions({ signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getExtensions>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetExtensionsSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getExtensions>>
>;
export type GetExtensionsSuspenseQueryError = AxiosError<unknown>;

export function useGetExtensionsSuspense<
    TData = Awaited<ReturnType<typeof getExtensions>>,
    TError = AxiosError<unknown>,
>(
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getExtensions>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetExtensionsSuspense<
    TData = Awaited<ReturnType<typeof getExtensions>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getExtensions>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetExtensionsSuspense<
    TData = Awaited<ReturnType<typeof getExtensions>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getExtensions>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetExtensionsSuspense<
    TData = Awaited<ReturnType<typeof getExtensions>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getExtensions>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetExtensionsSuspenseQueryOptions(options);

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getTimezones = (
    options?: AxiosRequestConfig
): Promise<AxiosResponse<IanaTimezoneView[]>> => {
    return axios.get(`/api/timezones`, options);
};

export const getGetTimezonesQueryKey = () => {
    return [`/api/timezones`] as const;
};

export const getGetTimezonesQueryOptions = <
    TData = Awaited<ReturnType<typeof getTimezones>>,
    TError = AxiosError<unknown>,
>(options?: {
    query?: Partial<
        UseQueryOptions<Awaited<ReturnType<typeof getTimezones>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
}) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetTimezonesQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTimezones>>> = ({
        signal,
    }) => getTimezones({ signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getTimezones>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTimezonesQueryResult = NonNullable<
    Awaited<ReturnType<typeof getTimezones>>
>;
export type GetTimezonesQueryError = AxiosError<unknown>;

export function useGetTimezones<
    TData = Awaited<ReturnType<typeof getTimezones>>,
    TError = AxiosError<unknown>,
>(
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getTimezones>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getTimezones>>,
                    TError,
                    Awaited<ReturnType<typeof getTimezones>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTimezones<
    TData = Awaited<ReturnType<typeof getTimezones>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getTimezones>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getTimezones>>,
                    TError,
                    Awaited<ReturnType<typeof getTimezones>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTimezones<
    TData = Awaited<ReturnType<typeof getTimezones>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getTimezones>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetTimezones<
    TData = Awaited<ReturnType<typeof getTimezones>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getTimezones>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetTimezonesQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetTimezonesSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getTimezones>>,
    TError = AxiosError<unknown>,
>(options?: {
    query?: Partial<
        UseSuspenseQueryOptions<
            Awaited<ReturnType<typeof getTimezones>>,
            TError,
            TData
        >
    >;
    axios?: AxiosRequestConfig;
}) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetTimezonesQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTimezones>>> = ({
        signal,
    }) => getTimezones({ signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getTimezones>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTimezonesSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getTimezones>>
>;
export type GetTimezonesSuspenseQueryError = AxiosError<unknown>;

export function useGetTimezonesSuspense<
    TData = Awaited<ReturnType<typeof getTimezones>>,
    TError = AxiosError<unknown>,
>(
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getTimezones>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTimezonesSuspense<
    TData = Awaited<ReturnType<typeof getTimezones>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getTimezones>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTimezonesSuspense<
    TData = Awaited<ReturnType<typeof getTimezones>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getTimezones>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetTimezonesSuspense<
    TData = Awaited<ReturnType<typeof getTimezones>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getTimezones>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetTimezonesSuspenseQueryOptions(options);

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}
